import React from 'react';
import { useTranslation } from 'react-i18next';
import bucketImg from '../../assets/images/icons/bucket-white.png';
import excavatorImg from '../../assets/images/icons/excavator-white.png';
import vehicleImg from '../../assets/images/icons/vehicle-white.png';
import workerImg from '../../assets/images/icons/worker-white.png';

const imageMap = {
    machine: excavatorImg,
    tool: bucketImg,
    staff: workerImg,
    vehicle: vehicleImg,
} as const;

export type CategoryType = keyof typeof imageMap;

const categoryColorMap: Record<CategoryType, string> = {
    machine: '#f39c12',
    tool: '#2980b9',
    vehicle: '#e67eeb',
    staff: 'whitesmoke',
};

interface CategoryCellProps {
    text?: string;
    stateColor?: string;
    textColor?: string;
    style?: React.CSSProperties;
    category: CategoryType;
    imageSize?: number;
}

const CategoryCell: React.FC<CategoryCellProps> = React.memo(({ text, stateColor, textColor = 'black', style, imageSize = 16, category }) => {
    const imgSrc = category ? imageMap[category] : undefined;
    const color = stateColor || (category ? categoryColorMap[category] : '#ccc');
    const label = text || category;
    const { t } = useTranslation();

    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'flex-start',
                alignItems: 'center',
            }}
        >
            <div
                style={{
                    borderColor: color,
                    borderWidth: 2,
                    borderStyle: 'solid',
                    borderRadius: 15,
                    paddingLeft: 15,
                    paddingRight: 15,
                    overflow: 'hidden',
                    position: 'relative',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    ...style,
                }}
            >
                <div
                    style={{
                        position: 'absolute',
                        inset: 0,
                        backgroundColor: color,
                        opacity: 0.3,
                        zIndex: 0,
                    }}
                />
                <div
                    style={{
                        position: 'relative',
                        zIndex: 1,
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'center',
                        gap: 10,
                    }}
                >
                    <img src={imgSrc} height={imageSize} width={imageSize} />
                    {t(label)}
                </div>
            </div>
        </div>
    );
});

export default CategoryCell;
